<script>
function deepClone(vnodes, createElement, index, value, scope) {
  function cloneVNode(vnode) {
    var clonedChildren = vnode.children && vnode.children.map(cloneVNode);

    var cloned = createElement(vnode.tag, vnode.data, clonedChildren);
    cloned.text = vnode.text;
    cloned.isComment = vnode.isComment;
    cloned.componentOptions = vnode.componentOptions;
    cloned.elm = vnode.elm;
    cloned.context = vnode.context;
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;

    if (cloned.data) {
      cloned.data.on = cloned.data.on || {};
      cloned.data.on.input = function (ev) {
        scope.$forceUpdate();
        scope.$emit("input", {
          index,
          name: ev.target.name,
          value: ev.target.value,
        });
      };
    }

    if (cloned.componentOptions) {
      cloned.componentOptions.listeners = cloned.componentOptions.listeners || {};
      cloned.componentOptions.listeners.input = function (ev) {
        scope.$forceUpdate();
        scope.$emit("input", {
          index,
          name: ev.target.name,
          value: ev.target.value,
        });
      };
    }

    if (
      cloned.data &&
      cloned.data.attrs &&
      cloned.data.attrs.name &&
      value &&
      value[cloned.data.attrs.name]
    ) {
      cloned.data.attrs.value = value[cloned.data.attrs.name];
    }

    if (cloned.data && cloned.data.attrs && cloned.data.attrs.condition) {
      switch (cloned.data.attrs.condition.op) {
        case "ne":
          if (
            scope.value &&
            scope.value[index] &&
            scope.value[index][cloned.data.attrs.condition.field] &&
            scope.value[index][cloned.data.attrs.condition.field].toLocaleLowerCase() ==
                cloned.data.attrs.condition.val.toLocaleLowerCase()
          )
            return null;
          break;
        default:
          if (
            !(
              scope.value &&
              scope.value[index] &&
              scope.value[index][cloned.data.attrs.condition.field] &&
              scope.value[index][cloned.data.attrs.condition.field].toLocaleLowerCase() ==
                cloned.data.attrs.condition.val.toLocaleLowerCase()
            )
          )
            return null;
          break;
      }
    }

    return cloned;
  }

  return vnodes.map(cloneVNode);
}

export default {
  props: {
    value: {
      required: false,
    },
  },
  data: function () {
    return {
      renderData: [{}],
    };
  },

  render: function (h) {
    var _this = this;

    return h(
      "div",
      {},
      this.renderData.map(function (el, index, obj) {
        return h("div", { key: el._id, style: { display: "flex" } }, [
          h(
            "div",
            {
              class: "array-item-wrapper",
              style: {
                display: "inline-block",
                width: "100%",
                "margin-top": "10px",
              },
            },
            deepClone(_this.$slots.default, h, index, el.value, _this)
          ),
          //button [-] :
          h(
            "div",
            {
              style: {
                width: "50px",
                "margin-top": "10px",
              },
            },
            [
              obj.length > 1
                ? h("input", {
                    attrs: {
                      type: "button",
                      value: "-",
                      index: index,
                      class: "btn-control",
                    },
                    on: { click: _this.del },
                  })
                : null,
              //button [+] :
              index == obj.length - 1
                ? h("input", {
                    attrs: {
                      type: "button",
                      value: "+",
                      class: "btn-control",
                    },
                    on: { click: _this.add },
                  })
                : null,
            ]
          ),
        ]);
      })
    );
  },

  methods: {
    add: function () {
      this.renderData.push({ _id: Date.now(), value: {} });
    },
    del: function (el) {
      this.renderData.splice(el.srcElement.attributes.index.value, 1);
    },
  },
};
</script>

